<div [formGroup]="reportGenerationForm" *ngIf="reportGenerationForm != null">
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="timeframe">Timeframe</label>
        <select class="form-control" id="timeframe" formControlName="timeframe">
          <option [value]="null" disabled>Select Report Type</option>
          <option *ngFor="let opt of timeframeOptions" [value]="opt.value">{{ opt.name }}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <label>Dates</label>
      <lib-date-range-picker formControlName="dateRange"></lib-date-range-picker>
    </div>
  </div>
  <div
    class="row"
    *ngIf="reportGenerationForm.errors?.['invalidDateRange'] && reportGenerationForm.touched">
    <div class="col-12">
      <p class="error-text">Begin date should be before End date</p>
    </div>
  </div>
  <div
    class="row"
    *ngIf="reportGenerationForm.errors?.['mustBeSameYear'] && reportGenerationForm.touched">
    <div class="col-12">
      <p class="error-text">Begin date and End Date must be in the same year.</p>
    </div>
  </div>

  <lib-report-buttons
    [formats]="formats"
    [disabled]="reportGenerationForm.invalid"
    (generateReport)="generateReport()"
    (downloadReport)="downloadReport($event)"></lib-report-buttons>
</div>
